import { NavHashLink } from 'react-router-hash-link';

function Footer() {
    return <footer>
        <p>
            Simon Adler<br />
            <a href="mailto:info@simonadler.de">info@simonadler.de</a><br />
            <NavHashLink to="/impressum#impressum">Impressum</NavHashLink> - <NavHashLink to="/impressum#datenschutz">Datenschutz</NavHashLink>
        </p>
        <p>&copy; {(new Date()).getFullYear()} Simon Adler</p>
    </footer>
}

export default Footer;